import UserArea from "../components/userPage/userArea"

export default function User(){
    return(
        <UserArea/>
    )
}